KlaviyoSubscribe.attachToForms('#email_signup_footer', {
  hide_form_on_success: false,
  success_message: "Thank you"
});

$(document).on('submit', '#email_signup_footer', function (e) {
  $('.err_msg').empty();

  var x = true;
  var form = $(this);
  var em = $(form).find('.email');
  var err_msg;

  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if(em.val().trim() == '') {
    if(err_msg == null){
      err_msg = 'Please enter email';
    }
    x = false;
  }
  if(!regex.test(em.val())){
    if(err_msg == null){
      err_msg = 'Please enter valid email';
    }
    x = false;
  }
  if( x == false){
    $(form).find('.err_msg').text(err_msg);
    return false;
  }

  // Lexer newsletter sign up
  lxt('identify', 'email', em.val());

});

$(function () {
  if ($(".newsletter_success").length) {
    $('html, body').animate({
      scrollTop: $(".newsletter_success").offset().top
    }, 1000);
  }
});
